import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

import { ApiService } from './api.service';

import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class QuotaService extends ApiService {
  constructor(private http: Http) {
    super('api/quotas/', http);
  }

  public create_movement(data): Observable<Object> {
    const url = this.apiUrl + 'api/quotas-movements/create_new_movement/';
    return this.http.post(url, data, { headers: this.getHeaders() }).map(this.extractData).catch(this.handleError);
  }

  public deleteMovement(id: number): Observable<void> {
    const url = this.apiUrl + 'api/quotas-movements/' + id + '/';
    return this.http.delete(url, { headers: this.getHeaders() }).catch(this.handleError);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/quota.service.ts